/* Shared enterprise UI tokens & primitives. Used across every page. */
import { Card, CardContent } from '../ui/card';

export const TONE = {
  critical: { text: 'text-[color:var(--mr-red-strong)]', bg: 'bg-[color:var(--mr-red-wash)]', border: 'border-[color:#d9363e40]', dot: 'bg-[color:var(--mr-red)]' },
  high:     { text: 'text-[color:var(--mr-warn)]',       bg: 'bg-[color:var(--mr-warn-wash)]', border: 'border-[color:#a8611640]', dot: 'bg-[color:var(--mr-warn)]' },
  warning:  { text: 'text-[color:var(--mr-warn)]',       bg: 'bg-[color:var(--mr-warn-wash)]', border: 'border-[color:#a8611640]', dot: 'bg-[color:var(--mr-warn)]' },
  info:     { text: 'text-[color:var(--mr-blue-strong)]', bg: 'bg-[color:var(--mr-blue-wash)]', border: 'border-[color:#1e4ce040]', dot: 'bg-[color:var(--mr-blue)]' },
  good:     { text: 'text-[color:var(--mr-ok)]',         bg: 'bg-[color:var(--mr-ok-wash)]',   border: 'border-[color:#16716340]', dot: 'bg-[color:var(--mr-ok)]' },
  ai:       { text: 'text-[color:var(--mr-blue-strong)]', bg: 'bg-[color:var(--mr-blue-wash)]', border: 'border-[color:#1e4ce040]', dot: 'bg-[color:var(--mr-blue)]' },
  neutral:  { text: 'text-muted-foreground',             bg: 'bg-muted/40',                    border: 'border-border',             dot: 'bg-muted-foreground' },
};

export function StatusChip({ tone = 'neutral', children, className = '' }) {
  const s = TONE[tone] || TONE.neutral;
  return <span className={`inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full border ${s.bg} ${s.border} ${s.text} ${className}`}>{children}</span>;
}

export function PageHeader({ title, subtitle, actions, children }) {
  return (
    <div className="mb-5" data-testid="enterprise-page-header">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground tracking-tight">{title}</h1>
          {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

export function StatCard({ icon: Icon, tone = 'neutral', label, value, sub, subTone, onClick, testId }) {
  const s = TONE[tone] || TONE.neutral;
  const subT = TONE[subTone || 'neutral'] || TONE.neutral;
  const inner = (
    <Card className="bg-card border-border hover:border-foreground/20 transition-colors h-full">
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          {Icon && <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 border ${s.bg} ${s.border}`}>
            <Icon size={18} weight="fill" className={s.text} />
          </div>}
          <div className="flex-1 min-w-0">
            <p className="text-[11px] text-muted-foreground font-medium uppercase tracking-wide">{label}</p>
            <p className="text-3xl font-bold text-foreground leading-tight mt-0.5">{value}</p>
            {sub && <p className={`text-xs mt-1 ${subT.text}`}>{sub}</p>}
          </div>
        </div>
      </CardContent>
    </Card>
  );
  return onClick
    ? <button onClick={onClick} className="text-left w-full" data-testid={testId}>{inner}</button>
    : <div data-testid={testId}>{inner}</div>;
}

// Small helper — used inline to color severity-based backgrounds
export function toneClasses(tone) { return TONE[tone] || TONE.neutral; }
